import type { SyntheticEvent } from "react"
import _t from "@core/i18n"
import useCurrentPathname from "~/hooks/useCurrentPathname"
import useLinkPropertiesCollection from "~/hooks/useLinkPropertiesCollection"
import { productBoxClickEvent } from "~/lib/analytics"
import comparePaths from "~/lib/comparePaths"

interface WidgetProps {
  title: string
  options: {
    text: string
    isActive: boolean
    onClick: (event: SyntheticEvent) => void
  }[]
  data?: Record<string, string>
}

export default function useWidgets(
  controls,
  options,
  onOptionValueSelect,
  connectedProducts,
  connectedControlsTitle
): WidgetProps[] {
  const currentPathName = useCurrentPathname()

  const connecteProductsLinksProps = useLinkPropertiesCollection(
    (connectedProducts || [])
      .filter((item) => item.flatData.pages && item.flatData.pages.length)
      .map((item) => item.flatData.pages[0].flatData.url)
  )

  const connectedProductsOptions = connectedProducts
    ? connectedProducts
        .filter((item) => item.flatData.pages && item.flatData.pages.length)
        .map((item) => {
          const linkProperties =
            connecteProductsLinksProps[item.flatData.pages[0].flatData.url]

          return {
            text: item.flatData.variant || item.flatData.name,
            isActive: comparePaths(currentPathName || "", linkProperties.href),
            onClick: (event) => {
              linkProperties.onClick(event)
              productBoxClickEvent({
                productbox_type: "button",
                productbox_option: item.flatData.variant,
                productbox_checked_item: item.flatData.name,
              })
            },
          }
        })
    : []

  const connectProductsWidgets: WidgetProps[] = []

  if (connectedProductsOptions.length) {
    connectProductsWidgets.push({
      title: connectedControlsTitle || _t("marketplace.packages"),
      options: connectedProductsOptions,
      data: { "data-test-id": "product-type-button" },
    })
  }

  const widgetsControls =
    controls &&
    controls.map((item) => {
      return {
        title: item.title,
        options: item.options.map((option) => {
          return {
            text: option.name,
            isActive: options[item.name] === option.value,
            onClick: () => {
              onOptionValueSelect(item.name, option.value)
              productBoxClickEvent({
                productbox_type: "button",
                productbox_option: option.name,
              })
            },
          }
        }),
        data: { "data-test-id": "product-config-button" },
      }
    })

  return [...connectProductsWidgets, ...(widgetsControls || [])]
}
